import { FC } from "react";
import { View } from "react-native";
import { Button, ButtonIcon } from "ui/gluestack/button";
import { ChevronLeftIcon, ChevronRightIcon } from "ui/gluestack/icon";

interface Props {
  onPrev: () => void;
  onNext: () => void;
}

export const PrevNextButtons: FC<Props> = ({ onPrev, onNext }) => {
  return (
    <View className="flex-row items-center">
      <Button
        action="tertiary"
        variant="solid"
        size="xs"
        className="rounded-l-xl px-3 bg-background-100 group"
        onPress={onPrev}
      >
        <ButtonIcon
          as={ChevronLeftIcon}
          className="w-4 h-4 text-background-800  group-hover:text-white"
        />
      </Button>
      <View className="w-px bg-background-300" />
      <Button
        action="tertiary"
        variant="solid"
        size="xs"
        className="rounded-r-xl px-3 bg-background-100 group"
        onPress={onNext}
      >
        <ButtonIcon
          as={ChevronRightIcon}
          className="w-4 h-4 text-background-800 group-hover:text-white"
        />
      </Button>
    </View>
  );
};
